import React from 'react';
import { Typography } from '@one-thd/sui-atomic-components';
import { currencyFormatter } from '../../../utils/currency-utils';
import { useViewChargedDetailsContext } from '../../../hooks/useContexts';
import { UNAVAILABLE_IMAGE_URL } from '../../../constants/general';

export const SelectedChargedLineItemsView: React.FC = () => {
  const { currentLineItemsView } = useViewChargedDetailsContext();
  const { transaction } = currentLineItemsView ?? {};

  if (!transaction) {
    return null;
  }

  return (
    <div className="sui-flex sui-flex-col sui-pr-4">
      {transaction?.lineItems?.map((lineItem, lIndex) => (
        <div
          key={
            lineItem.omsId ??
            lineItem.skuNumber ??
            `${transaction.transactionType}-${lIndex}`
          }
          className="sui-flex sui-flex-row sui-justify-between sui-items-center sui-mb-4"
          data-testid="charge-history-item"
        >
          <div className="sui-flex sui-flex-row sui-items-center">
            <img
              src={lineItem.imageUrl || UNAVAILABLE_IMAGE_URL}
              alt={
                lineItem.itemDescFromCatalog?.trim() ||
                lineItem.itemDescFromPOS?.trim() ||
                'Product image'
              }
              width={64}
              height={64}
              className="sui-w-16 sui-h-16 sui-object-cover"
            />
            <Typography>
              {lineItem.itemDescFromCatalog || lineItem.itemDescFromPOS || ''}
            </Typography>
          </div>
          <div className="sui-flex sui-flex-col sui-items-end">
            <Typography>
              {currencyFormatter.format(Number(lineItem.unitPrice))}
            </Typography>
            <Typography>Qty: {lineItem.quantity}</Typography>
          </div>
        </div>
      ))}
      <div className="sui-flex sui-justify-between sui-pt-2 sui-border-t-2 sui-border-solid sui-border-primary">
        <Typography weight="bold">Item(s) Totals:</Typography>
        <Typography weight="bold">
          {currencyFormatter.format(Number(transaction?.itemTotal))}
        </Typography>
      </div>
    </div>
  );
};
